export default __webpack_public_path__ + "static/media/button__invite.929df46b.svg";